<div class="edit-page-root-container kitchen-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <!-- New Staff Attendance Fields -->
                        <div class="input-group" style="gap: 22px;">
                            <mat-form-field class="employee" *ngIf="areaId!==0">
                                <mat-label>Employee</mat-label>
                                <input matInput formControlName="employee_name" placeholder="Select or enter employee" readonly>
                                <mat-error *ngIf="editForm.controls['employee_name'].hasError('required')">Employee is required</mat-error>
                            </mat-form-field>
                            <mat-form-field class="employee" *ngIf="areaId==0">
                                <mat-label>Employee</mat-label>
                                <mat-select formControlName="employee_id">
                                    <mat-option *ngFor="let employee of employeeList" [value]="employee.id"> {{ employee.f_name }} {{ employee.l_name }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="editForm.controls['employee_id'].hasError('required')">Employee is required</mat-error>
                            </mat-form-field>
                            <div style="display: flex; align-items: center; gap: 16px;">
                                <mat-form-field class="shift" style="width: 250px;">
                                    <mat-label>Shift</mat-label>
                                    <mat-select formControlName="shift">
                                        <mat-option *ngFor="let shift of shiftOptions" [value]="shift.value">{{ shift.label }}</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="editForm.controls['shift'].hasError('required')">Shift is required</mat-error>
                                </mat-form-field>
                                <span class="shift-time-display">
                                    {{ shiftTimeDisplay }}
                                </span>
                            </div>
                        </div>
                        <div class="input-group" style="gap: 22px;">
                            <div style="display: flex; flex-direction: column; min-width: 320px;">
                                <label class="break-label">Start Time</label>
                                <div style="display: flex; align-items: center; gap: 12px;">
                                    <mat-form-field style="width: 160px;">
                                        <mat-label>Date</mat-label>
                                        <input matInput [matDatepicker]="pickerStart" formControlName="shift_start_date">
                                        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerStart></mat-datepicker>
                                        <mat-error *ngIf="editForm.get('shift_start_date')?.hasError('required') && editForm.get('shift_start_date')?.touched">
                                            Please select a date.
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field style="width: 110px;">
                                        <mat-label>Hour</mat-label>
                                        <mat-select formControlName="shift_start_hour">
                                            <mat-option *ngFor="let hour of hoursList" [value]="hour">{{ hour }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width: 115px;">
                                        <mat-label>Minute</mat-label>
                                        <mat-select formControlName="shift_start_minute">
                                            <mat-option *ngFor="let m of mintList" [value]="m">{{ m }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <mat-error *ngIf="(editForm.get('shift_start_hour')?.hasError('required') || editForm.get('shift_start_minute')?.hasError('required')) && (editForm.get('shift_start_hour')?.touched || editForm.get('shift_start_minute')?.touched)">
                                    Please select both hour and minute.
                                </mat-error>
                            </div>
                            <div style="display: flex; flex-direction: column; min-width: 320px;">
                                <label class="break-label">End Time</label>
                                <div style="display: flex; align-items: center; gap: 12px;">
                                    <mat-form-field style="width: 160px;">
                                        <mat-label>Date</mat-label>
                                        <input matInput [matDatepicker]="pickerEnd" formControlName="shift_end_date">
                                        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerEnd></mat-datepicker>
                                        <mat-error *ngIf="editForm.get('shift_end_date')?.hasError('required') && editForm.get('shift_end_date')?.touched">
                                            Please select a date.
                                        </mat-error>
                                       

                                    </mat-form-field>
                                    <mat-form-field style="width: 110px;">
                                        <mat-label>Hour</mat-label>
                                        <mat-select formControlName="shift_end_hour">
                                            <mat-option *ngFor="let hour of hoursList" [value]="hour">{{ hour }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width: 115px;">
                                        <mat-label>Minute</mat-label>
                                        <mat-select formControlName="shift_end_minute">
                                            <mat-option *ngFor="let m of mintList" [value]="m">{{ m }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    
                                </div>
                                <mat-error *ngIf="editForm.get('shift_end_date')?.hasError('datesNotMatch')">
  Start Date and End Date must be the same.
</mat-error>
 <mat-error *ngIf="(editForm.get('shift_end_hour')?.hasError('required') || editForm.get('shift_end_minute')?.hasError('required')) && (editForm.get('shift_end_hour')?.touched || editForm.get('shift_end_minute')?.touched)">
                                    Please select both hour and minute.
                                </mat-error>
                            </div>
                        </div>
                        <div class="input-group break-row" style="gap: 54px;">
                            <div class="break-col" style="min-width: 220px;">
                                <label class="break-label">Break Start</label>
                                <div class="break-select-row" style="gap: 8px;">
                                    <mat-form-field style="width: 110px;">
                                        <mat-label>Hour</mat-label>
                                        <mat-select formControlName="breakStart" placeholder="Hour">
                                            <mat-option *ngFor="let hour of hoursList" [value]="hour">{{ hour }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="colon-separator">:</span>
                                    <mat-form-field style="width: 110px;">
                                        <mat-label>Minute</mat-label>
                                        <mat-select formControlName="breakStartMint" placeholder="Minute">
                                            <mat-option *ngFor="let m of mintList" [value]="m">{{ m }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="break-col" style="min-width: 220px;">
                                <label class="break-label">Break End</label>
                                <div class="break-select-row" style="gap: 8px;">
                                    <mat-form-field style="width: 100px;">
                                        <mat-label>Hour</mat-label>
                                        <mat-select formControlName="breakEnd" placeholder="Hour">
                                            <mat-option *ngFor="let hour of hoursList" [value]="hour">{{ hour }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="colon-separator">:</span>
                                    <mat-form-field style="width: 100px;">
                                        <mat-label>Minute</mat-label>
                                        <mat-select formControlName="breakEndMint" placeholder="Minute">
                                            <mat-option *ngFor="let m of mintList" [value]="m">{{ m }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="upb-col" style="min-width: 140px; display: flex; flex-direction: column; align-items: flex-start;">
                                <label class="break-label">UPB</label>
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <mat-form-field style="width: 70px;">
                                        <mat-label>Hour</mat-label>
                                        <mat-select formControlName="upbHour">
                                            <mat-option *ngFor="let hour of hoursList" [value]="hour">{{ hour }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="colon-separator">:</span>
                                    <mat-form-field style="width: 70px;">
                                        <mat-label>Minute</mat-label>
                                        <mat-select formControlName="upbMinute">
                                            <mat-option *ngFor="let m of mintList" [value]="m">{{ m }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="input-group" style="flex-direction: column;">
                            <div class="reason-detail" style="width: 100%;">
                                <span class="reason-label">Reason for change</span>
                                <mat-radio-group formControlName="entry_reason">
                                    <div class="reason-options-3col">
                                        <div class="reason-col">
                                            <mat-radio-button *ngFor="let opt of reasonOptions.slice(0,2)" [value]="opt.value">{{opt.label}}</mat-radio-button>
                                        </div>
                                        <div class="reason-col">
                                            <mat-radio-button *ngFor="let opt of reasonOptions.slice(2,4)" [value]="opt.value">{{opt.label}}</mat-radio-button>
                                        </div>
                                        <div class="reason-col">
                                            <mat-radio-button *ngFor="let opt of reasonOptions.slice(4,6)" [value]="opt.value">{{opt.label}}</mat-radio-button>
                                        </div>
                                    </div>
                                </mat-radio-group>
                                 <mat-error *ngIf="(editForm.get('entry_reason')?.hasError('required') || editForm.get('shift_start_minute')?.hasError('required')) && (editForm.get('entry_reason')?.touched || editForm.get('entry_reason')?.touched)">
                                    Please select the reason for change
                                </mat-error>
                            </div>
                        </div>
                        <mat-form-field class="reason-detail" style="width: 100%;">
                            <mat-label>State the detail reason for change</mat-label>
                            <textarea matInput formControlName="reasonDetail"
                              [disabled]="editForm.get('entry_reason')?.value !== 6"></textarea>
                        </mat-form-field>
                        <!-- End new fields -->
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>